import { jsx as _jsx } from "react/jsx-runtime";
import { Transition as MantineTransition } from '@mantine/core';
import { Transition as ThemeTransition } from '../../theme';
import { StyledWrapper } from './Transition.style';
export const transitionTypes = [
    'fade',
    'scale',
    'scale-y',
    'scale-x',
    'skew-up',
    'skew-down',
    'rotate-left',
    'rotate-right',
    'slide-down',
    'slide-up',
    'slide-left',
    'slide-right',
    'pop',
    'pop-bottom-left',
    'pop-bottom-right',
    'pop-top-left',
    'pop-top-right',
];
export function Transition({ animation = 'fade', children, duration = ThemeTransition.Duration.In, visible = true, minHeight = 120, }) {
    return (_jsx(MantineTransition, { duration: duration, mounted: visible, timingFunction: "ease", transition: animation, children: (styles) => (_jsx(StyledWrapper, { style: Object.assign(Object.assign({}, styles), { position: 'absolute', top: 0, left: 0, right: 0, minHeight, height: '100%' }), children: children })) }));
}
//# sourceMappingURL=Transition.js.map